import React from 'react';
import { useStore } from '@/state/store';
import { useI18n } from '@/i18n/I18nContext';
import { Slider } from '@/components/ui/slider';
import { Scaling } from 'lucide-react';

// Per-page element zoom. Scales ONLY the device/edge layer (size + spacing);
// the CAD frame, legend and title block keep their fixed proportions. Range
// 25%..200%; click the value to reset to 100%.
export const ElementZoomControl = ({ page }) => {
  const { t } = useI18n();
  const setPageScale = useStore((s) => s.setPageScale);
  if (!page) return null;
  const pct = Math.round((page.contentScale || 1) * 100);
  return (
    <div className="flex items-center gap-2" title={t('element_zoom_hint')} data-testid="element-zoom-control">
      <Scaling className="h-3.5 w-3.5 text-muted-foreground" />
      <span className="hidden text-xs text-[#2A3138] xl:inline">{t('element_zoom')}</span>
      <Slider
        value={[pct]}
        min={25}
        max={200}
        step={5}
        onValueChange={(v) => setPageScale(page.id, (v[0] || 100) / 100)}
        className="w-24"
        aria-label={t('element_zoom')}
        data-testid="element-zoom-slider"
      />
      <button
        type="button"
        onClick={() => setPageScale(page.id, 1)}
        className="w-10 shrink-0 rounded px-1 py-0.5 text-right font-mono text-xs text-[#2A3138] transition-colors duration-150 hover:bg-muted"
        title="100%"
        data-testid="element-zoom-value"
      >
        {pct}%
      </button>
    </div>
  );
};
